import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../shared/services/language.service';
import { ReferralInfo } from '../seller';
import { referralsGetInfoService } from './referrals-get-info.service';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss']
})
export class ReferralsComponent implements OnInit {
  constructor(
    private refInfo: referralsGetInfoService,
    private snackBar: MatSnackBar,
    public translate: TranslateService,
    public languageService: LanguageService
  ) { }
  baseUrl = '';
  referalInfo: ReferralInfo = {
    countRedeemed: 0,
    countAll: 0,
    code: '',
    value: {
      limit_value: 0,
      receiver_value: 0,
      sender_value: 0
    }
  };
  async ngOnInit() {
    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
    this.baseUrl = location.protocol + '//' + location.host + '/seller/referral/';

    try {
      this.referalInfo = await this.refInfo.make();
      console.log(this.referalInfo);
    } catch (err) {
      console.log(err);
    }
  }
  copyInputMessage(inputElement: any) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.snackBar.open(this.translate.instant('Sellers.Products.CopiedToClipboard'), '', {
      duration: 3000
    });
  }
}
